import { EventType, InteractionRequiredAuthError, PublicClientApplication } from '@azure/msal-browser';
import axios from 'axios';

const clientId = process.env.REACT_APP_METAL_CLIENT_ID;
const tenantId = process.env.REACT_APP_METAL_TENANT_ID;
const authority = `https://login.microsoftonline.com/${tenantId}`;

console.log("[MSAL ENV] clientId:", clientId);
console.log("[MSAL ENV] tenantId/domain:", tenantId);

export const msalInstance = new PublicClientApplication({
  auth: {
    clientId: clientId,
    authority: authority,
    redirectUri: window.location.origin
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false
  }
});

export const loginRequest = { scopes: ["User.Read"] };

let initPromise = null;

export async function ensureInitialized() {
  if (!initPromise) {
    initPromise = msalInstance.initialize();
  }
  return initPromise;
}

let loginInProgress = false;

export async function loginUser(loginRequest) {
  await ensureInitialized();

  if (loginInProgress) {
    throw new Error('interaction_in_progress');
  }

  loginInProgress = true;

  try {
    const response = await msalInstance.loginRedirect ?
      (await msalInstance.loginPopup(loginRequest)) :
      (await msalInstance.loginPopup(loginRequest));
    return response.account;
  } finally {
    loginInProgress = false;
  }
}

export async function logoutUser() {
  await ensureInitialized();
  return msalInstance.logoutRedirect();
}


export async function getGraphProfile(select = "displayName,mail,userPrincipalName,department,officeLocation,jobTitle") {
  const account = msalInstance.getActiveAccount() ||msalInstance.getAllAccounts()[0];
  if (!account) {
    return null;
  }

  try {
    const { accessToken } = await msalInstance.acquireTokenSilent({
      account,
      scopes: ["User.Read"],
    });

    const res = await axios.get(`https://graph.microsoft.com/v1.0/me?$select=${encodeURIComponent(select)}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }, 
      validateStatus: () => true
    });

    const ct = res.headers['content-type'] || "";
    console.log("[Graph] status:", res.status, res.statusText);
    console.log("[Graph] headers:", res.headers);
    console.log("[Graph] data:", res.data);

    if (res.status < 200 || res.status >= 300 || ct.includes("text/html")) {
      return null;
    }
    return res.data; // axios already parsed JSON
  } catch (e) {
    if (e instanceof InteractionRequiredAuthError) {
      return null;
    }
    throw e;
  }
}


export async function getSwaUser() {
  try {
    const res = await fetch('/.auth/me', { credentials: 'include' });
    if (!res.ok) return null;
    const data = await res.json();
    return data[0]?.clientPrincipal || null;
  } catch (e) {
    console.error("Error fetching SWA user:", e);
    return null;
  }
}


export async function bootstrapMsal() {
  await ensureInitialized();

  const redirectResult = await msalInstance.handleRedirectPromise();
  if(redirectResult?.account) {
    msalInstance.setActiveAccount(redirectResult.account);
  }

  const existing = msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
  if (existing) {
    msalInstance.setActiveAccount(existing);
  }

  msalInstance.addEventCallback((e) => {
    if(e.eventType === EventType.ACQUIRE_TOKEN_SUCCESS && e.payload?.account) {
      msalInstance.setActiveAccount(e.payload.account);
    }
  });

  return msalInstance.getActiveAccount();
}